import { render, staticRenderFns } from "./IntentionDefine.vue?vue&type=template&id=edb7d76e&scoped=true"
import script from "./IntentionDefine.vue?vue&type=script&lang=js"
export * from "./IntentionDefine.vue?vue&type=script&lang=js"
import style0 from "./IntentionDefine.vue?vue&type=style&index=0&id=edb7d76e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb7d76e",
  null
  
)

export default component.exports